import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { EPrijemnicaPrevoz } from './eprijemnica-prevoz';

@Component({
  selector: 'yt-eprijemnica-prevoz-inline-update',
  templateUrl: './eprijemnica-prevoz-inline-update.component.html'
})
export class EPrijemnicaPrevozInlineUpdateComponent
 extends BaseInlineUpdateComponent<EPrijemnicaPrevoz> {
  constructor(protected inlineContainerService: InlineContainerService<EPrijemnicaPrevoz>){
    super(inlineContainerService);
  }
}
